import { Box, Flex, Image } from '@mantine/core';
import { motion } from 'motion/react';
import { AccountBalance } from '../account';
import { CashoutAnimation } from '../CashoutAnimation';
import { FreeBetsStartModal } from '../FreeBetsStartModal';
import { FreeBetsSummaryModal } from '../FreeBetsSummaryModal';
import { MobileHeader } from '../MobileHeader';
import { RatAnimation } from '../RatAnimation';
import { SessionCheckModal } from '../SessionCheckModal';
import { SettingsButton } from '../settings/SettingsButton';
import { ConfigureAutoBetModal } from './auto-bet/ConfigureAutoBetModal';
import styles from './Game.module.css';
import { GameAside } from './GameAside';
import { GameContent } from './GameContent';

export const Game = () => {
  return (
    // On small screens: one column; on md and above: two columns (first column fixed to 24rem)
    <>
      <SessionCheckModal />
      <FreeBetsStartModal />
      <FreeBetsSummaryModal />
      <motion.div
        animate={{ opacity: 1 }}
        className={styles['game-container']}
        data-test-id="game-container"
        initial={{ opacity: 0 }}
        transition={{ duration: 0.25 }}
      >
        <ConfigureAutoBetModal />
        <MobileHeader />
        <GameAside />

        <Box className={styles['game-content']} pos="relative">
          <Image
            bottom={0}
            data-test-id="game-background-image"
            fit="cover"
            h="100%"
            left={0}
            pos="absolute"
            right={0}
            src="/game/background.webp"
            style={{
              objectPosition: 'center',
              userSelect: 'none',
            }}
            top={0}
            w="100%"
          />
          <GameContent />
          <Box
            data-test-id="game-animation-container"
            display={{
              base: 'none',
              lg: 'block',
            }}
            pos="relative"
          >
            <CashoutAnimation />

            <RatAnimation />
          </Box>
          <Box visibleFrom="lg">
            <Flex
              align={{
                base: 'flex-start',
                xl: 'flex-end',
              }}
              direction={{
                base: 'row-reverse',
                xl: 'column',
              }}
              gap={8}
              pos="absolute"
              right={{
                base: 8,
                md: 16,
                lg: 24,
              }}
              style={{ zIndex: 50 }}
              top={{
                base: 8,
                xl: 24,
              }}
            >
              <SettingsButton />
              <AccountBalance />
            </Flex>
          </Box>
        </Box>
      </motion.div>
    </>
  );
};
